import { TABLA_DETALLE_POR_CEREAL_LINEA_5 } from '../../../../../config/tables'
import { COLUMNS_DETALLE_POR_CEREAL_LINEA_5, COLUMNS_DETALLE_POR_CEREAL_LINEA_5_TO_PRINT } from './constantesDetallePorCerealLinea5'
import { TablaDetallePorCerealLinea5Service } from '../../../../../models/movimiento/distribucionDetallePorCereal/Tabla_detalle_por_cereal_linea_5'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_POR_CEREAL_LINEA_5
    })
    const promiseTablaDetalleCerealPorLinea5 = TablaDetallePorCerealLinea5Service.getDataTablaDetallePorCerealLinea5()
    const promiseTablaDetallePorCerealLinea5Total = TablaDetallePorCerealLinea5Service.getDataTablaDetallePorCerealLinea5Total()
    Promise.all([promiseTablaDetalleCerealPorLinea5, promiseTablaDetallePorCerealLinea5Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Cereal Manipuleo',
        dataCombinada,
        COLUMNS_DETALLE_POR_CEREAL_LINEA_5_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_POR_CEREAL_LINEA_5,
          data: dataCombinada,
          title: `Cereal Sector 5 Manipuleo`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, print: false, pagination: false }
        },
        id: TABLA_DETALLE_POR_CEREAL_LINEA_5
      })
    }
  }
}
